import axios from 'axios';
const danismanGET = async () => {
  let response;
  var config = {
    method: 'get',
    url: process.env.REACT_APP_API_URL + '/api/v1/danisman',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      authorization: 'bearer ' + localStorage.getItem('accessToken'),
    },
  };
  await axios(config)
    .then((res) => {
      response = res;
    })
    .catch((err) => {
      console.log(err);
      response = err;
    });
  return response;
};

const danismanCreate = async (data) => {
  let response;
  var config = {
    method: 'post',
    url: process.env.REACT_APP_API_URL + '/api/v1/danisman/create',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      authorization: 'bearer ' + localStorage.getItem('accessToken'),
    },
    data: data,
  };
  await axios(config)
    .then((res) => {
      response = res;
    })
    .catch((err) => {
      console.log(err);
      response = err;
    });
  return response;
};

const danismanUpdate = async (id, data) => {
  let response;
  var config = {
    method: 'put',
    url: process.env.REACT_APP_API_URL + '/api/v1/danisman/' + id,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      authorization: 'bearer ' + localStorage.getItem('accessToken'),
    },
    data: data,
  };
  await axios(config)
    .then((res) => {
      response = res;
    })
    .catch((err) => {
      console.log(err);
      response = err;
    });
  return response;
};

const danismanOnayMail = async (data) => {
  let response;
  var config = {
    method: 'post',
    url: process.env.REACT_APP_API_URL + '/api/v1/danisman/seminerOnayMail',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      authorization: 'bearer ' + localStorage.getItem('accessToken'),
    },
    data: data,
  };
  await axios(config)
    .then((res) => {
      response = res;
    })
    .catch((err) => {
      console.log(err);
      response = err;
    });
  return response;
};

export { danismanGET, danismanCreate, danismanUpdate, danismanOnayMail };
